"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schoolCodeList = exports.peCourseList = exports.majorSourceList = exports.getShoolNavigations = exports.getShoolByCode = exports.categoriesList = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
//专业大类
var categoriesList = exports.categoriesList = function categoriesList(data) {
  return _api.default.request({
    url: '/major/categories/list',
    method: 'post',
    data: data
  });
};
var schoolCodeList = exports.schoolCodeList = function schoolCodeList(data) {
  return _api.default.request({
    url: '/school/openList',
    method: 'get',
    params: data
  });
};
var majorSourceList = exports.majorSourceList = function majorSourceList(data) {
  return _api.default.request({
    url: '/major/info/web/list',
    method: 'post',
    data: data
  });
};
var peCourseList = exports.peCourseList = function peCourseList(data) {
  return _api.default.request({
    url: '/peCourse/getReceptionList',
    method: 'post',
    data: data
  });
};
var getShoolByCode = exports.getShoolByCode = function getShoolByCode(data) {
  return _api.default.request({
    url: '/web/getShoolByCode',
    method: 'post',
    data: data
  });
};
//导航管理
var getShoolNavigations = exports.getShoolNavigations = function getShoolNavigations(data) {
  return _api.default.request({
    url: '/web/getShoolNavigations',
    method: 'post',
    data: data
  });
};